// extracted by mini-css-extract-plugin
export default {"LegendContainer":"LegendContainer","LegendUnit":"LegendUnit","LegendScale":"LegendScale","LegendValues":"LegendValues","LegendValue":"LegendValue","mapboxgl-ctrl":"mapboxgl-ctrl"};